import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MediaProcessJobOverview from './media-process-job-overview-model'
import {
  CreateMediaProcessJobOverviewAsync,
  DeleteMediaProcessJobOverviewAsync,
  LoadMediaProcessJobOverviewsAsync,
} from './mediaProcessJobOverview-thunk'
const initialState: mediaProcessJobOverviewSliceState = {
  mediaProcessJobOverview: [],
  selected_mediaProcessJobOverview: '',
  is_loading_mediaProcessJobOverview: false,
  is_creating_mediaProcessJobOverview: false,
  is_deleting_mediaProcessJobOverview: false,
}
export interface mediaProcessJobOverviewSliceState {
  mediaProcessJobOverview: MediaProcessJobOverview[]
  selected_mediaProcessJobOverview?: string
  is_loading_mediaProcessJobOverview: boolean
  is_creating_mediaProcessJobOverview: boolean
  is_deleting_mediaProcessJobOverview: boolean
}
export const mediaProcessJobOverviewSlice = createSlice({
  name: 'mediaProcessJobOverview',
  initialState,
  reducers: {
    setSelectedmediaProcessJobOverview: (state, action) => {
      state.selected_mediaProcessJobOverview = action.payload
    },
    clearStatemediaProcessJobOverview: (state) => {
      state.mediaProcessJobOverview = []
      state.is_loading_mediaProcessJobOverview = false
      state.is_creating_mediaProcessJobOverview = false
      state.is_deleting_mediaProcessJobOverview = false
    },
    mergemediaProcessJobOverview: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaProcessJobOverview = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaProcessJobOverview = merge(
            state.mediaProcessJobOverview,
            payload,
          ) as any
        }
      }
    },

    add_mediaProcessJobOverview: (state, action) => {
      if (action.payload) {
        state.mediaProcessJobOverview = [
          ...state.mediaProcessJobOverview,
          action.payload,
        ]
      }
    },
    set_mediaProcessJobOverview: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaProcessJobOverview = state.mediaProcessJobOverview.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaProcessJobOverviewsAsync.pending, (state) => {
      state.is_loading_mediaProcessJobOverview = true
    })
    builder.addCase(
      LoadMediaProcessJobOverviewsAsync.fulfilled,
      (state, action) => {
        state.is_loading_mediaProcessJobOverview = false
        if (action.payload) {
          state.mediaProcessJobOverview = action.payload
        }
      },
    )
    builder.addCase(LoadMediaProcessJobOverviewsAsync.rejected, (state) => {
      state.is_loading_mediaProcessJobOverview = false
    })
    builder.addCase(CreateMediaProcessJobOverviewAsync.pending, (state) => {
      state.is_creating_mediaProcessJobOverview = true
    })
    builder.addCase(CreateMediaProcessJobOverviewAsync.fulfilled, (state) => {
      state.is_creating_mediaProcessJobOverview = false
    })
    builder.addCase(CreateMediaProcessJobOverviewAsync.rejected, (state) => {
      state.is_creating_mediaProcessJobOverview = false
    })
    builder.addCase(DeleteMediaProcessJobOverviewAsync.pending, (state) => {
      state.is_deleting_mediaProcessJobOverview = true
    })
    builder.addCase(
      DeleteMediaProcessJobOverviewAsync.fulfilled,
      (state, action) => {
        state.is_deleting_mediaProcessJobOverview = false
        if (state.mediaProcessJobOverview) {
          state.mediaProcessJobOverview = state.mediaProcessJobOverview.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteMediaProcessJobOverviewAsync.rejected, (state) => {
      state.is_deleting_mediaProcessJobOverview = false
    })

    builder.addCase(
      autoThunks.retrieve_media_processing_job_overview.pending,
      (state) => {
        state.is_loading_mediaProcessJobOverview = true
      },
    )
    builder.addCase(
      autoThunks.retrieve_media_processing_job_overview.fulfilled,
      (state, action) => {
        state.is_loading_mediaProcessJobOverview = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.retrieve_media_processing_job_overview.rejected,
      (state) => {
        state.is_loading_mediaProcessJobOverview = false
      },
    )
  },
})

function handleResult(action: any, state: mediaProcessJobOverviewSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_mediaProcessJobOverview = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.mediaProcessJobOverview = merge(
        state.mediaProcessJobOverview,
        payload,
      ) as any
    }
  }
}

export const {
  clearStatemediaProcessJobOverview,
  setSelectedmediaProcessJobOverview,
  set_mediaProcessJobOverview,
  mergemediaProcessJobOverview,
  add_mediaProcessJobOverview,
} = mediaProcessJobOverviewSlice.actions

export const get_mediaProcessJobOverview =
  (id?: string) =>
  (state: {
    mediaProcessJobOverview: {
      mediaProcessJobOverview: MediaProcessJobOverview[]
    }
  }): MediaProcessJobOverview | null => {
    let temp = state?.mediaProcessJobOverview?.mediaProcessJobOverview?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.mediaProcessJobOverview?.mediaProcessJobOverview[0] || null
  }
export const get_selected_mediaProcessJobOverview = (state: {
  mediaProcessJobOverview: mediaProcessJobOverviewSliceState
}): MediaProcessJobOverview | null => {
  let id = state?.mediaProcessJobOverview?.selected_mediaProcessJobOverview
  let temp = state?.mediaProcessJobOverview?.mediaProcessJobOverview?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaProcessJobOverview = (state: {
  mediaProcessJobOverview: {
    mediaProcessJobOverview: MediaProcessJobOverview[]
  }
}): MediaProcessJobOverview[] => {
  let temp = state?.mediaProcessJobOverview?.mediaProcessJobOverview
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaProcessJobOverview_busy = (state: {
  mediaProcessJobOverview: mediaProcessJobOverviewSliceState
}) => {
  return (
    state?.mediaProcessJobOverview.is_deleting_mediaProcessJobOverview ||
    state?.mediaProcessJobOverview.is_loading_mediaProcessJobOverview ||
    state?.mediaProcessJobOverview.is_creating_mediaProcessJobOverview
  )
}
export const is_deleting_mediaProcessJobOverview_busy = (state: {
  mediaProcessJobOverview: mediaProcessJobOverviewSliceState
}) => {
  return state?.mediaProcessJobOverview.is_deleting_mediaProcessJobOverview
}
export const is_loading_mediaProcessJobOverview_busy = (state: {
  mediaProcessJobOverview: mediaProcessJobOverviewSliceState
}) => {
  return state?.mediaProcessJobOverview.is_loading_mediaProcessJobOverview
}
export const is_creating_mediaProcessJobOverview_busy = (state: {
  mediaProcessJobOverview: mediaProcessJobOverviewSliceState
}) => {
  return state?.mediaProcessJobOverview.is_creating_mediaProcessJobOverview
}

export default mediaProcessJobOverviewSlice.reducer
